import { defineComponent, h } from 'vue';
import { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator, QSpinner, QTooltip } from 'quasar';
import BaseComponent from './BaseAgGridMixin.jsx';
import utils from '../../Shared/utils.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import careService from '@/Services/careService.jsx';
import methods from '@/Shared/methods'
import { AgGridVue } from "ag-grid-vue3";
import DropdownFilter from './vuecontrols/agGridDropdownFilter.vue';
import _ from 'lodash';

import TranslationContainer from './TranslationContainer.jsx';

const AsyncFunction = async function () { }.constructor;

const CellButton = defineComponent({
    components: { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator },
    data: () => ({
        type: 'CellButton',
    }),
    created() {
        if (this.btn.Condition && !this.btn.$$Condition)
            this.btn.$$Condition = utils.compileExpression(this, this.btn.Condition, this.cd.RowModelName || 'row');

        if (this.btn.Icon && !this.btn.$$Icon)
            this.btn.$$Icon = utils.compile(this, this.btn.Icon, false, this.cd.RowModelName || 'row');

        if (this.btn.Color && !this.btn.$$Color)
            this.btn.$$Color = utils.compile(this, this.btn.Color, false, this.cd.RowModelName || 'row');

        if (this.btn.Tooltip && !this.btn.$$Tooltip)
            this.btn.$$Tooltip = utils.compile(this, this.Translate(this.btn.Tooltip), false, this.cd.RowModelName || 'row');
    },
    props: {
        root: null,
        btn: null,
        cd: null,
        params: null,
        scopeitems: null,
        controlscope: null,
        c_context: null,
        rowData: null,
    },
    methods: {
        ...methods,
        rowMenuClick(e, data, btn, m) {
            //e.cancelBubble = true;
            //e.preventDefault();
            utils.executeAndCompileAllActions(m.Actions, { RowIndex: -1, Data: this.rowData }, this.c_context);
        },
        menuOpenClose(state, data, btn, m) {
            if (btn.OnMenuOpen)
                utils.executeAndCompileAllActions(btn.OnMenuOpen, { RowIndex: -1, Data: this.rowData, State: state }, this.c_context);
        },
        rowCommandClick(e, data, btn) {
            e.cancelBubble = true;
            e.preventDefault();
            //debugger;
            utils.executeAndCompileAllActions(btn.Actions, { RowIndex: this.params.node.rowIndex, Data: this.rowData }, this.c_context);
        },
        //used in the grid to calculate the value of the command column.
        getEvaluationResults(button, context, data) {
            var condition = (button.$$Condition ? utils.evaluate(button.$$Condition, context, false, null, false, data) : null);

            return {
                condition: condition,
                color: (button.$$Color && condition ? utils.evaluate(button.$$Color, context, false, null, false, data) : null),
                icon: (button.$$Icon && condition ? utils.evaluate(button.$$Icon, context, false, null, false, data) : null)
            };
        }
    },
    render() {
        const data = this.rowData;
        const btn = this.btn;

        if(!data) return;

        if (btn.$$Condition && !utils.evaluate(btn.$$Condition, this.c_context, false, null, false, data))
            return null;

        let color;
        if (btn.$$Color)
            color = utils.evaluate(btn.$$Color, this.c_context, false, null, false, data);

        let icon;
        if (btn.$$Icon)
            icon = utils.evaluate(btn.$$Icon, this.c_context, false, null, false, data);

        let tooltip;
        if (btn.$$Tooltip) {
            tooltip = <QTooltip transition-show="scale" transition-hide="scale">
                {utils.renderTooltipContent(utils.evaluate(btn.$$Tooltip, this.c_context, false, null, false, data))}
            </QTooltip>;
        }

        const iconName = icon ? String(icon).replace(/^\s*mdi\s+/, '').trim() || icon : 'mdi-circle';
        let b;
        if (btn.Menu && btn.Menu.length > 0) {
            const showTrigger = !btn.$$Condition || utils.evaluate(btn.$$Condition, this.c_context, false, null, false, data);
            const items = [];
            for (let i = 0; i < btn.Menu.length; i++) {
                const m = btn.Menu[i];
                if (m.Separator)
                    items.push(<QSeparator key={`sep-${i}`} />);
                else {
                    if (!utils.document_cache.hasAccess('fastgrid command button menu', m.AccessPermission))
                        continue;

                    if (m.DisplayExpression && !m.$$displayexpn)
                        m.$$displayexpn = utils.compileExpression(this, m.DisplayExpression, this.cd.RowModelName || 'row');

                    if (m.$$displayexpn && !utils.evaluate(m.$$displayexpn, this.c_context, false, null, false, data))
                        return;

                    if (m.EnabledExpression && !m.$$enabledexpn)
                        m.$$enabledexpn = utils.compileExpression(this, m.EnabledExpression, this.cd.RowModelName || 'row');

                    if (m.Icon && !m.$$iconexpn)
                        m.$$iconexpn = utils.compile(this, m.Icon, this.cd.RowModelName || 'row');

                    if (m.Icon && m.IconColor && !m.$$iconcolorexpn)
                        m.$$iconcolorexpn = utils.compile(this, m.IconColor, this.cd.RowModelName || 'row');

                    let menuicon;
                    if (m.$$iconexpn) {
                        let iconcolor;
                        if (m.$$iconcolorexpn)
                            iconcolor = utils.evaluate(m.$$iconcolorexpn, this.c_context, false, null, false, data);
                        const menuIconName = String(utils.evaluate(m.$$iconexpn, this.c_context, false, null, false, data)).replace(/^\s*mdi\s+/, '').trim();
                        menuicon = <QIcon name={menuIconName} size="sm" style={iconcolor ? { color: iconcolor } : undefined} />;
                    }

                    const menudisabled = (m.$$enabledexpn && !utils.evaluate(m.$$enabledexpn, this.c_context, false, null, false, data));
                    items.push(
                        <QItem key={i}
                            clickable
                            disable={menudisabled}
                            onClick={(e) => this.rowMenuClick(e, data, btn, m)}>
                            {menuicon ? <QItemSection avatar>{menuicon}</QItemSection> : null}
                            <QItemSection>
                                <QItemLabel><TranslationContainer context={this} value={m.Title} /></QItemLabel>
                            </QItemSection>
                        </QItem>
                    );
                }
            }

            b = (
                <QBtn flat dense round
                    class="q-mr-sm"
                    icon={iconName}
                    size="sm"
                    style={{ ...(color ? { color } : {}), ...(showTrigger ? {} : { display: 'none' }) }}>
                    <QMenu
                        auto-close
                        onShow={() => this.menuOpenClose(true, data, btn)}
                        onHide={() => this.menuOpenClose(false, data, btn)}>
                        <QList dense>
                            {items}
                        </QList>
                    </QMenu>
                </QBtn>
            );
        }
        else if (btn.Actions && btn.Actions.length > 0)
            b = (
                <QBtn flat dense round
                    class="q-mr-sm"
                    icon={iconName}
                    size="sm"
                    style={color ? { color } : undefined}
                    onClick={(e) => this.rowCommandClick(e, data, btn)}>
                    {tooltip}
                </QBtn>
            );
        else
            b = (
                <QBtn flat dense round
                    style={{ cursor: 'default', ...(color ? { color } : {}) }}
                    class="q-mr-sm"
                    icon={iconName}
                    size="sm"
                    xdisable>
                    {tooltip}
                </QBtn>
            );

        //if (btn.$$Tooltip) {
        //    const tooltip = utils.evaluate(btn.$$Tooltip, this.c_context, false, null, false, data);
        //    if (tooltip)
        //        b = utils.generateTooltip(h, b, tooltip, 'right');
        //}

        return b;
    }
});

const CellTemplate = defineComponent({
    components: {
        CellButton,
    },
    data: () => ({
        root: null,
        type: 'CellTemplate',
        columnDef: null,
        scopeitems: null,
        controlscope: null,

        c_context: null,
        rowData: null,
    }),
    created() {
        // Copy parameters into fields so our interpolations will work
        this.root = this.params.callcorp.root;
        this.columnDef = this.params.callcorp.columnDef;
        this.scopeitems = this.params.callcorp.scopeitems;
        this.controlscope = this.params.callcorp.controlscope;
        this.c_context = this.params.callcorp.context;
        this.rowData = this.params.data; // <-- for reactivity
    },
    methods: {
        rowCommandClick(e, data, btn) {
            e.cancelBubble = true;
            e.preventDefault();
            utils.executeAndCompileAllActions(btn.Actions, { RowIndex: -1, Data: this.params.data }, this.c_context);
        },
        rowLinkClick(e, data, actions) {
            e.cancelBubble = true;
            e.preventDefault();
            utils.executeAndCompileAllActions(actions, { RowIndex: -1, Data: this.params.data }, this.c_context);
        },
        rowMenuClick(e, data, btn, m) {
            //e.cancelBubble = true;
            //e.preventDefault();
            utils.executeAndCompileAllActions(m.Actions, { RowIndex: -1, Data: this.params.data }, this.c_context);
        },
        menuOpenClose(state, data, btn, m) {
            if (btn.OnMenuOpen)
                utils.executeAndCompileAllActions(btn.OnMenuOpen, { RowIndex: -1, Data: this.params.data, State: state }, this.c_context);
        },
    },
    render() {
        const buttons = [];
        const cd = this.columnDef;
        if (cd.condition_expn)
            if (!utils.evaluate(cd.condition_expn, this.c_context, false, null, false, this.params.data))
                return null;

        if (this.columnDef.CommandButtons)
            for (let j = 0; j < this.columnDef.CommandButtons.length; j++) {
                const btn = this.columnDef.CommandButtons[j];

                if (!utils.document_cache.hasAccess('fastgrid command button', btn.AccessPermission))
                    continue;

                buttons.push(
                    <CellButton
                        btn={btn}
                        cd={cd}
                        root={this.root}
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        c_context={this.c_context}
                        rowData={this.rowData}
                        params={this.params}
                    >
                    </CellButton>
                );
            }

        return <span>{buttons}</span>;
    }
});

export default defineComponent({
    name: 'fast-grid',
    mixins: [BaseComponent],
    components: {
        AgGridVue,
        CellTemplate,
        DropdownFilter,
        QList,
        QItem,
        QItemSection,
        QItemLabel,
        QIcon,
        QSpinner,
    },
    data: function () {
        return {
            column_defs_ready: false,
            dataTypeDefinitions: {
                customColumn: {
                    filter: 'agTextColumnFilter',
                    filterParams: { debounceMs: 1000 },
                }
            },
            serverDataSource: {
                getRows: async (server) => {
                    const params = server.request;
                    console.log(`params: ${JSON.stringify(params)}`);

                    // params: {"startRow":0,"endRow":100,"sortModel":[{"sort":"asc","colId":"starttime"}],"filterModel":{}}
                    // params: {"startRow":0,"endRow":100,"sortModel":[{"sort":"desc","colId":"prequeuetime"}],
                    //          "filterModel":{"callerid":{"filterType":"text","type":"contains","filter":"5432"}}}

                    try {
                        const output = await this.runUserQuery(params);
                        server.success(output);

                        // Ensure we preserve any selected rows
                        if (this.selectedRowsData && this.selectedRowsData.length > 0)
                            this.SetSelectedRows(this.selectedRowsData, true);
                    }
                    catch (er) {
                        console.error(`serverDataSource.getRows failed:`);
                        console.error(JSON.stringify(params));
                        console.error(er);
                        server.fail();
                    }
                }
            },

            dynamicColumns: null,
            columnTemplates: null,
            dsFunc: null,
            column_defs: null,
        }
    },
    created() {
        if (this.controlData.EnableDynamicColumns && this.controlData.DynamicColumns) {
            this.dynamicColumns = utils.compileObject(this, this.controlData.DynamicColumns, 'rows');
            this.columnTemplates = careHelpfulFunctions.toLookup(this.controlData.ColumnTemplates, 'Name');
        }

        if (this.controlData.SelectOptions && this.controlData.SelectOptions.Enable && this.controlData.SelectOptions.SelectableExpression)
            this.selectableexpn = utils.compileExpression(this, this.controlData.SelectOptions.SelectableExpression, 'row');

        if (this.controlData.RowModelType == 'serverSide' && this.controlData.DataSourceFunction) {
            this.dsFunc = new AsyncFunction(['baseurl', 'args', 'api', 'care', 'util', 'Control', 'Params'], this.controlData.DataSourceFunction);
            this.debouncedSearchRefresh = _.debounce(() => this.Refresh(false, true), 500);

            this.modelurl_watch$ = this.$watch(
                function () {
                    return this.modelurlvalue;
                },
                function (val, oldval) {
                    utils.debug(`FastGrid ${this.name} URL value changed to: ${val}`);
                    this.Refresh();
                }
            );
        }

        if(this.controlData.GroupingOptions?.PanelShowExpression){
            this.controlData.GroupingOptions.panelshow_expn = utils.compileExpression(this, this.controlData.GroupingOptions.PanelShowExpression, 'rows');
        }
        if(this.controlData.GroupingOptions?.ColumnsExpandedExpression){
            this.controlData.GroupingOptions.columnsexpanded_expn = utils.compileExpression(this, this.controlData.GroupingOptions.ColumnsExpandedExpression, 'rows');
        }

        this.useBuiltInExport = true;

        this.prepareColumnDefs();
    },
    computed: {
        dataSource: function () {
            return this.modelfunc ? this.modelfunc : null;
        },
        dynamicColumnsValue: function () {
            return utils.evaluateObject(this.dynamicColumns, this, this.dataSource);
        },
        rowModelType: function () {
            return this.controlData.RowModelType || 'clientSide';
        },
        serverSideDatasource: function () {
            if (this.rowModelType == 'serverSide')
                return this.serverDataSource;
            return undefined;
        },
        searchTextReader: function () {
            // The quick filter text cannot be used for serverSide row model, so this
            // only applies when using clientSide.
            return this.rowModelType == 'clientSide' ? this.searchText : '';
        },
        QuckSearchText: function () {
            return this.searchText;
        },
    },
    watch: {
        dataSource: function (newVal, oldVal) {
            if (!this.column_defs_ready) {
                this.prepareColumnDefs();
            }
            // Dynamic columns are derived from row data (e.g. getDynamicColumns(rows)).
            // created() often prepares before the URL returns, leaving an empty column set
            // with column_defs_ready true; rebuild when the data source actually changes.
            else if (this.controlData.EnableDynamicColumns && newVal !== oldVal) {
                this.prepareColumnDefs();
            }
        },
        // Restore default settings resets the column visibility and bumps columnDefsVersion. This grid builds its own
        // column_defs once, so rebuild them or the remounted grid keeps the saved layout's hidden columns until a reload.
        columnDefsVersion: function () {
            this.column_defs_ready = false;
            this.prepareColumnDefs();
        },
        searchText: function (newVal, oldVal) {
            if (this.rowModelType == 'serverSide' && this.debouncedSearchRefresh)
                this.debouncedSearchRefresh();
        },
    },
    //Mounted Replaced with preRenderComplete
    methods: {
        
        getIsOpenGroupOptionCallback(){
            if(!this.controlData.GroupingOptions?.RememberOpenedGroups) return null;

            return (e) => {
                 let data = this.System.LocalStorage(this.storageKey + '-expanded-groups') || "{}";
                 let obj = {};
                 try { obj = JSON.parse(data); }catch{ return false; };
                 return obj[e.rowNode.id] == 1;
            }
        },

        onRowGroupOpened(e) {
            
            if(!this.controlData.GroupingOptions?.RememberOpenedGroups) return;

            let data = this.System.LocalStorage(this.storageKey + '-expanded-groups') || "{}";
            let obj = {};
            try { obj = JSON.parse(data); }catch{  };

            obj[e.node.id] = e.node.expanded ? 1 : 0;
            this.System.LocalStorage(this.storageKey + '-expanded-groups',JSON.stringify(obj));
        },

        async Refresh(clearSelectedRows, purge) {
            if (this.rowModelType == 'serverSide') {
                if (clearSelectedRows)
                    this.ClearSelectedRows();

                if (this.gridApi)
                    this.gridApi.refreshServerSide(purge ? { purge: true } : undefined);
                // Else do nothing, we are initializing still
            }
            else
                this.internalRefresh(clearSelectedRows);
        },

        prepareColumns() {
            // Generate compiled expressions for all interpolations
            for (let i = 0; i < this.columnDefs.length; i++) {
                const cd = this.columnDefs[i];

                if (cd.Condition)
                    cd.condition_expn = utils.compileExpression(this, cd.Condition, cd.RowModelName || 'row');

                for (let j = 0; j < cd.CommandButtons.length; j++) {
                    const btn = cd.CommandButtons[j];

                    if (btn.Condition)
                        btn.$$Condition = utils.compileExpression(this, btn.Condition, cd.RowModelName || 'row');

                    if (btn.Icon)
                        btn.$$Icon = utils.compile(this, btn.Icon, false, cd.RowModelName || 'row');

                    if (btn.Color)
                        btn.$$Color = utils.compile(this, btn.Color, false, cd.RowModelName || 'row');

                    if (btn.Tooltip)
                        btn.$$Tooltip = utils.compile(this, btn.Tooltip, false, cd.RowModelName || 'row');
                }
            }
        },

        // A column definition that throws used to leave column_defs_ready false for good, and
        // render() returns null in that state, so the whole grid silently disappeared over one bad
        // column. Fall back to a plain column instead and let the rest of the grid load.
        async safeGenerateColumnDef(h, cd, col, index, originalDataField, headerCaption, istemplate, default_visible, enableRowGroup, groupByDefault) {
            try {
                return await this.generateColumnDef(h, cd, col, index, originalDataField, headerCaption, istemplate, default_visible, enableRowGroup, groupByDefault);
            }
            catch (e) {
                utils.warn(`FastGrid ${this.name}: column "${headerCaption || originalDataField}" could not be prepared, falling back to a plain column`, e);
                return {
                    headerName: headerCaption,
                    field: originalDataField,
                    colId: (col && col.Name) || originalDataField,
                    sortable: true,
                    filter: true,
                    resizable: true,
                    initialHide: !default_visible,
                };
            }
        },
        // prepareColumnDefs() is called from created() without being awaited, so anything that threw
        // in here became an unhandled rejection, column_defs_ready stayed false, and render() then
        // returned null for the life of the component: the grid never appeared and the only trace
        // was a console error. Always publish whatever was built.
        async prepareColumnDefs() {
            let coldefs;
            try {
                coldefs = await this.buildColumnDefs();
            }
            catch (e) {
                utils.warn(`FastGrid ${this.name}: failed to prepare column definitions`, e);
            }

            this.column_defs = coldefs;
            this.column_defs_ready = true;
        },
        async buildColumnDefs() {
            //const h = this.$createElement;
            let coldefs;
            if (!this.controlData.EnableDynamicColumns && this.columnDefs && this.columnDefs.length > 0) {
                coldefs = [];

                //if (this.controlData.SelectOptions.Enable) {
                //    let checkboxVisible = true;
                //    if (this.selectableexpn)
                //        checkboxVisible = ({ data }) => !data || utils.evaluate(this.selectableexpn, this, false, null, false, data);

                //    coldefs.push({
                //        headerName: '',
                //        sortable: false,
                //        resizable: true,
                //        checkboxSelection: checkboxVisible,
                //        headerCheckboxSelection: this.controlData.RowModelType != 'serverSide',
                //        headerCheckboxSelectionFilteredOnly: true,
                //        showDisabledCheckboxes: this.controlData.SelectOptions.ShowDisabledCheckboxes == true,
                //        pinned: 'left',
                //        width: 50
                //    });
                //}

                for (let i = 0; i < this.columnDefs.length; i++) {
                    const cd = this.columnDefs[i];

                    utils.debug(`pushing regular coldef for field:${cd.Field} as name:${cd.Name}`);
                    
                    let rowGroup = cd.RowGroup;
                    if(cd.EnableRowGroup && typeof rowGroup === "string"){
                        let rowgroup_expn = utils.compileExpression(this, cd.RowGroup, 'ColumnDef');
                        rowGroup = utils.evaluate(rowgroup_expn, this, false, false, false, cd);
                    }

                    const originalDataField = cd.Field;
                    const headerCaption = this.Translate(cd.DisplayName || cd.Name || cd.Field || '');
                    coldefs.push(await this.safeGenerateColumnDef(h, cd, cd, i, originalDataField, headerCaption, false, cd.Visible, cd.EnableRowGroup, rowGroup));

                }
            }
            else if (this.controlData.EnableDynamicColumns && this.dynamicColumns && this.columnTemplates) {
                coldefs = [];

                if (this.controlData.SelectOptions.Enable) {
                    let checkboxVisible = true;
                    if (this.selectableexpn)
                        checkboxVisible = ({ data }) => utils.evaluate(this.selectableexpn, this, false, null, false, data)

                    coldefs.push({
                        headerName: '',
                        sortable: false,
                        resizable: true,
                        checkboxSelection: checkboxVisible,
                        headerCheckboxSelection: true,
                        showDisabledCheckboxes: this.controlData.SelectOptions.ShowDisabledCheckboxes == true,
                        pinned: 'left',
                        width: 50,

                        suppressHeaderFilterButton: false,
                        suppressHeaderMenuButton: false,
                        mainMenuItems: ['pinSubMenu', 'separator', 'sortAscending', 'sortDescending', 'sortUnSort', 'separator', 'autoSizeThis', 'autoSizeAll', 'separator', 'resetColumns'],
                    });
                }

                const dc = this.dynamicColumnsValue;
                if (dc && Array.isArray(dc)) {
                    // Read this.columns_visible from local storage if present
                    const cv = this.System.LocalStorage(this.storageKey + '-columns_visible');
                    if (cv && this.useLocalStorage)
                        this['columns_visible'] = JSON.parse(cv);

                    if (!cv || this.columns_visible.length !== dc.length)
                        this.columns_visible = dc.map(d => d.default_visible === undefined ? true : d.default_visible);

                    this.init_columns_visible = [...this.columns_visible];

                    for (let i = 0; i < dc.length; i++) {
                        const cd = this.columnTemplates[dc[i].template];
                        if (!cd) continue;

                        utils.debug(`pushing templated coldef for field:${dc[i].field}, template:${dc[i].template}`);
                        const originalDataField = dc[i].field; // Assuming dc[i].field is the raw field name
                        const headerCaption = this.Translate(dc[i].caption || dc[i].field || '');

                        coldefs.push(await this.safeGenerateColumnDef(h, cd, dc[i], i, originalDataField, headerCaption, true, dc[i].default_visible === undefined ? true : dc[i].default_visible, false, false))
                    }
                }
            }
            
            return coldefs;
        },
        async generateColumnDef(h, cd, col, index, originalDataField, headerCaption, istemplate, default_visible, enableRowGroup, groupByDefault) {
            // cd is the columnDef - which, for a template, is reused for multiple columns.
            // col is either the columnDef or the dynamicColumn - it is passed as a place to cache
            //     compiled expressions for the column since it needs to be distinct per column even
            //     for dynamic columns. For non-templated columns, it is the same as cd.

            // originalDataField is the raw key for data access.
            // headerCaption is the translated string for the header.

            if (!cd.visibleexpr && cd.Visible && typeof cd.Visible === 'string') {
                cd.visibleexpr = utils.compileObject(this, cd.Visible);
            }

            let field_extractor = col.field_extractor;
            if (!field_extractor)
                field_extractor = new Function('f', `return f != null && typeof f === 'object' && "${originalDataField}" in f ? f["${originalDataField}"] : null;`);

            // Cache this to prevent regular recompile
            //if (!istemplate)
            col.field_extractor = field_extractor;

            if (col.condition_expn && col.value_expn) // cd.Value is an expression for the cell value
                col.condition_expn = utils.compileExpression(this, cd.Condition, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);
            
            let cellFilterFunc;

            if (cd.ActionOnlyColumn) {
                const def = ({
                    headerName: this.Translate(cd.DisplayName),
                    resizable: true,
                    sortable: false,
                    menuTabs: [],
                    cellRenderer: 'CellTemplate',
                    cellRendererParams: {
                        callcorp: {
                            root: this.root,
                            columnDef: cd,
                            scopeitems: this.scopeitems,
                            controlscope: this.controlscope,
                            context: this,
                        }
                    },
                    valueGetter: (node) => {
                        
                        var callcorp = node.colDef.cellRendererParams.callcorp;
                        var colDef = callcorp?.columnDef;

                        let data;

                        if (colDef && node.data) {
                            data = {
                                colData: col.condition_expn ? utils.evaluate(col.condition_expn, callcorp.context, false, null, false, node.data) : null,
                                colActionData: colDef.CommandButtons?.map(button => CellButton.methods.getEvaluationResults(button, callcorp.context, node.data))
                            };
                        } else {
                            data = {
                                colData: null,
                                colActionData: null
                            }
                        }

                        return data;
                    },
                    equals: (l, r) => {
                        return _.isEqual(l, r);
                    },

                    suppressHeaderFilterButton: true,
                    suppressHeaderMenuButton: true,
                    mainMenuItems: [],
                });
              if (cd.Width > 0) {
                def.width = parseInt(cd.Width);
              }

              return def;
            }
            else {
                let dataType;
                if (cd.DataType && cd.DataType != 'default')
                    dataType = cd.DataType;

                let valueGetter;
                if (cd.Value && !col.value_expn)
                    col.value_expn = utils.compile(this, cd.Value, false, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);

                if (col.condition_expn && col.value_expn)
                    valueGetter = (node) => node.data && utils.evaluate(col.condition_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) ? utils.evaluate(col.value_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) : '';
                else if (col.value_expn)
                    valueGetter = (node) => node.data && utils.evaluate(col.value_expn, this, false, null, false, [node.data, field_extractor(node.data)], true);
                //else if (cd.condition_expn)
                //    valueGetter = (node) => utils.evaluate(cd.condition_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) ? field_extractor(node.data) : '';

                let valueFormatter;
                if (cd.CellFilter && !col.cellfilter_expn) {
                    const filter = `{{ row["${originalDataField}"] | ${cd.CellFilter} }}`;
                    col.cellfilter_expn = utils.compile(this, filter, false, ['row', cd.ItemModelName || 'item']);
                }
                if (col.cellfilter_expn && col.condition_expn)
                    valueFormatter = (node) => node.data && utils.evaluate(col.condition_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) ? utils.evaluate(col.cellfilter_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) : '';
                else if (col.cellfilter_expn && !col.condition_expn)
                    valueFormatter = (node) => node.data && utils.evaluate(col.cellfilter_expn, this, false, null, false, [node.data, field_extractor(node.data)], true);
                else if (col.condition_expn && !valueGetter)
                    valueFormatter = (node) => node.data && utils.evaluate(col.condition_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) ? field_extractor(node.data) : '';

                if (!valueGetter && !valueFormatter) {
                    const code = `return data !== null && typeof data === 'object' ? JSON.stringify(data) : data;`;
                    const func = new Function('data', code);
                    valueFormatter = (node) => {
                        try { return func(field_extractor(node.data)); } catch (e) {
                            utils.warn(`Grid cell failed to evaluate ${code}`, e); return '';
                        }
                    };
                }

                let cellEditorProps;
                if (cd.Editable) {
                    if (cd.EditableSettings?.ListValuesExpression)
                        cd.listvaluesexpn = utils.compileExpression(this, cd.EditableSettings.ListValuesExpression);
                    cellEditorProps = {
                        editable: true,
                        cellEditor: cd.EditableSettings?.CellEditor, // 'agRichSelectCellEditor',
                        cellEditorParams: {
                            values: cd.listvaluesexpn ? () => utils.evaluate(cd.listvaluesexpn, this) : undefined,
                            multiSelect: cd.EditableSettings?.MultiSelect,
                            formatValue: (value) => value,
                        },
                    };
                }

                const cdef = {
                    headerName: headerCaption, // Use the translated caption
                    field: originalDataField,  // Use the original field for data binding
                    colId: col.Name || originalDataField, // col.Name might be untranslated, originalDataField is safer for ID
                    sortable: cd.Sortable,
                    filter: true,
                    resizable: true,
                    comparator: this.colSortComparator,
                    // Use initialHide (not hide) so refreshing/reapplying columnDefs does not
                    // overwrite visibility the user changed via the grid menu or column API.
                    initialHide: !this.init_columns_visible[index],
                    rowGroup: groupByDefault == true,
                    enableRowGroup: enableRowGroup == true,

                    suppressHeaderFilterButton: false,
                    suppressHeaderMenuButton: false,
                    mainMenuItems: ['pinSubMenu', 'separator', 'sortAscending', 'sortDescending', 'sortUnSort', 'separator', 'autoSizeThis', 'autoSizeAll', 'separator', 'resetColumns'],
                    ...cellEditorProps,
                };

                // This will hold the lookup table to transform cell values into display values
                let lookup;

                if (cd.Lookup && cd.Lookup.SourceType != 'None') {
                    // Lookups can't use a value getter or formatter, it overrides the lookup
                    valueGetter = null;
                    valueFormatter = null;

                    let displayExpr;
                    switch (cd.Lookup.DisplayType) {
                        case 'Field':
                            displayExpr = cd.Lookup.DisplayField;
                            break;
                        case 'Expression':
                            const displayfunc = utils.compileExpression(this, cd.Lookup.DisplayExpression, cd.RowModelName);
                            displayExpr = (item) => utils.evaluate(displayfunc, this, false, null, false, item);
                            break;
                    }
                    let valueExpr;
                    switch (cd.Lookup.ValueType) {
                        case 'Field':
                            valueExpr = cd.Lookup.ValueField;
                            break;
                        case 'Expression':
                            const valuefunc = utils.compileExpression(this, cd.Lookup.ValueExpression, cd.RowModelName);
                            valueExpr = (item) => utils.evaluate(valuefunc, this, false, null, false, item);
                            break;
                    }

                    const transformer = (rows) => Object.fromEntries(rows.map(r => {
                        const value = typeof valueExpr === 'string' ? r[valueExpr] : valueExpr(r);
                        const display = typeof displayExpr === 'string' ? r[displayExpr] : displayExpr(r);
                        return [value, display];
                    }));

                    let dataSource;

                    // The lookup used to be a one-shot snapshot taken while the column was built.
                    // A Raw source is usually a GlobalVars.* value that a background service fills
                    // in from an API call, so it can still be empty at that point, and the column
                    // then stayed blank until the page was reloaded. resolveLookup keeps trying
                    // while the lookup is empty and repaints once it fills.
                    let resolveLookup = () => lookup;
                    let lookupRetryAt = 0;

                    switch (cd.Lookup.SourceType) {
                        case 'Raw':
                            if (!cd.Lookup.dataSourceExpr)
                                cd.Lookup.dataSourceExpr = utils.compileObject(this, cd.Lookup.SourceRaw);

                            dataSource = utils.evaluateObject(cd.Lookup.dataSourceExpr, this);

                            // Transform the array into an object
                            // cdef.refData = transformer(dataSource);
                            lookup = transformer(dataSource || []);

                            resolveLookup = () => {
                                // Throttled: while the source is missing the expression warns on
                                // every evaluation, and a retry per cell would flood the console.
                                if (Object.keys(lookup).length === 0 && Date.now() - lookupRetryAt > 250) {
                                    lookupRetryAt = Date.now();
                                    try {
                                        const latest = utils.evaluateObject(cd.Lookup.dataSourceExpr, this);
                                        if (Array.isArray(latest) && latest.length > 0) {
                                            lookup = transformer(latest);
                                            // Repaint the cells that already rendered empty. Deferred
                                            // so the grid is not refreshed from inside a value getter.
                                            setTimeout(() => this.gridApi && this.gridApi.refreshCells({ force: true }), 0);
                                        }
                                    }
                                    catch (e) {
                                        utils.warn(`Grid lookup for ${originalDataField} failed to re-evaluate`, e);
                                    }
                                }
                                return lookup;
                            };

                            valueGetter = (node) => resolveLookup()[field_extractor(node.data)];
                            break;

                        case 'URL':
                            cdef.refData = {};

                            if (!cd.Lookup.dataSourceUrl)
                                cd.Lookup.dataSourceUrl = utils.compile(this, cd.Lookup.SourceURL);

                            let url = utils.evaluate(cd.Lookup.dataSourceUrl, this);
                            let res = await utils.api.get(url, false, cd.Lookup.CacheResults);

                            utils.debug(`Lookup returned: ${JSON.stringify(res)}`);

                            //cdef.refData = transformer(res);
                            // A failed or empty lookup request threw here and took the whole grid
                            // down with it, the way the Raw branch above used to.
                            lookup = transformer(res || []);

                            utils.debug(`Transformed to: ${JSON.stringify(cdef.refData)}`);
                            break;
                    }

                    if (lookup) {
                        if (cd.Lookup.NotFoundText && !cd.Lookup.notfoundexpn)
                            cd.Lookup.notfoundexpn = utils.compile(this, cd.Lookup.NotFoundText, null, cd.RowModelName);

                        valueGetter = (node) => node?.data && (resolveLookup()[field_extractor(node.data)] || (cd.Lookup.notfoundexpn ? utils.evaluate(cd.Lookup.notfoundexpn, this, null, null, null, node.data) : ''));
                        valueFormatter = valueGetter;

                        cdef.valueGetter = valueGetter;
                    }

                    // Enterprise feature
                    //cdef.filter = 'agSetColumnFilter'; 
                    //cdef.cellEditor = 'select';
                    //cdef.cellEditorParams = { values: Object.keys(cdef.refData) };

                    // cdef.refData = { key: value, ... }
                }

                if (valueFormatter)
                    cdef.valueFormatter = valueFormatter;

                if (valueGetter)
                    cdef.valueFormatter = valueGetter;
                    //cdef.valueGetter = valueGetter;

                if (cd.SortAndFilterTemplate) {
                    if (!col.sorttemplate_expn)
                        col.sorttemplate_expn = utils.compile(this, cd.SortAndFilterTemplate, false, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);

                    if (col.condition_expn)
                        cdef.valueGetter = (node) => node.data && utils.evaluate(col.condition_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) ? utils.evaluate(col.sorttemplate_expn, this, false, null, false, [node.data, field_extractor(node.data)], true) : '';
                    else
                        cdef.valueGetter = (node) => node.data && utils.evaluate(col.sorttemplate_expn, this, false, null, false, [node.data, field_extractor(node.data)], true);
                }

                if (cd.CellClassExpression) {
                    if (!col.cellclassexpr)
                        col.cellclassexpr = utils.compileExpression(this, cd.CellClassExpression, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);

                    if (col.cellclassexpr)
                        cdef.cellClass = (node) => {
                            const v = utils.evaluate(col.cellclassexpr, this, false, null, false, [node.data, node.data ? field_extractor(node.data) : null], true);
                            if (!v) return '';
                            return v;
                        };
                }

                if (cd.Align == 'Right') {
                    if (cdef.cellClass && typeof cdef.cellClass === 'function') {
                        const oldfunc = cdef.cellClass;
                        cdef.cellClass = (node) => [oldfunc(node), 'right-aligned-cell'];
                    }
                    else
                        cdef.cellClass = cdef.cellClass ? [cdef.cellClass, 'right-aligned-cell'] : 'right-aligned-cell'; // 'rightAligned';

                    cdef.headerClass = 'ag-right-aligned-header';
                }

                if (cd.Align == 'Center') {
                    if (cdef.cellClass && typeof cdef.cellClass === 'function') {
                        const oldfunc = cdef.cellClass;
                        cdef.cellClass = (node) => [oldfunc(node), 'center-aligned-cell'];
                    }
                    else
                        cdef.cellClass = cdef.cellClass ? [cdef.cellClass, 'center-aligned-cell'] : 'center-aligned-cell'; // 'rightAligned';

                    cdef.headerClass = 'ag-center-aligned-header';
                }

                if (cd.HeaderType && cd.HeaderType != 'StandardMenu') {
                    cdef.filter = cd.HeaderType == 'NoFilter' ? false : (cd.HeaderType == 'DefaultFilter' ? 'agSetColumnFilter' : cd.HeaderType);
                    cdef.menuTabs = ['filterMenuTab'];

                    if(cd.HeaderType != "DefaultFilter"){
                        cdef.menuTabs.push('generalMenuTab');
                    }

                    switch (cd.HeaderType) {
                        case 'DropdownFilter':
                            cdef.filterParams = {
                                label: `Select Filter for ${cdef.DisplayName || cdef.name || cdef.field}:`,
                            };
                            break;

                        case 'agMultiColumnFilter':
                            cdef.filterParams = {
                                filters: [
                                    {
                                        filter: 'agTextColumnFilter',
                                        filterParams: {
                                            filterOptions: cd.FilterOptions.CompareChoices,
                                            buttons: ['reset'],
                                        }
                                    },
                                    {
                                        filter: 'agSetColumnFilter',
                                        filterParams: {
                                            values: this.getUniqueColValuesFunc(cd),
                                            refreshValuesOnOpen: cd.UniqueValues?.RefreshValuesOnOpen,
                                        }
                                    }
                                ],
                            };
                            if (lookup)
                                cdef.filterParams.filters[0].valueFormatter = (params) => lookup[params.value];
                            break;

                        case 'agSetColumnFilter':
                            cdef.filterParams = {
                                values: this.getUniqueColValuesFunc(cd),
                                refreshValuesOnOpen: cd.UniqueValues?.RefreshValuesOnOpen
                            };
                            if (lookup)
                                cdef.filterParams.valueFormatter = (params) => lookup[params.value];
                            break;

                        case 'agTextColumnFilter':
                        case 'agNumberColumnFilter':
                        case 'agDateColumnFilter':
                            cdef.filterParams = {
                                filterOptions: cd.FilterOptions.CompareChoices,
                                buttons: ['reset'],
                            };
                            break;
                    }

                    console.log('columnDef: ' + JSON.stringify(cdef, null, 3));
                }

                if (false && cd.LinkActions && cd.LinkActions.length > 0) {
                    const scopedSlots = {
                        default: ({ data }) =>
                            <v-btn elevation={0} class="text-capitalize"
                                small
                                text
                                on-click={(e) => this.rowLinkClick(e, data, cd.LinkActions)}
                            >
                                {cellFilterFunc(data.row.data)}
                            </v-btn>
                    };

                    const buttons = [];
                    buttons.push(
                        <DxButton scopedSlots={scopedSlots}>
                        </DxButton>
                    );
                    return (
                        <DxColumn
                            type="buttons"
                            name={name || field}
                            caption={caption || name || field}
                            data-field={originalDataField}
                            data-type={dataType}
                            calculate-cell-value={cellFilterFunc}
                            calculate-sort-value={cd.sortandfilterfunc}
                            visible={this.columns_visible[index]}
                        >
                            {buttons}
                        </DxColumn>
                    );
                }
                else
                    return cdef;
            }
        },
        getUniqueColValuesFunc(cd) {
            if (!cd.UniqueValues) return [];

            if (cd.UniqueValues.ValueType == 'Expression' && cd.UniqueValues.ValueExpression && !cd.UniqueValues.valueexpn)
                cd.UniqueValues.valueexpn = utils.compileExpression(this, cd.UniqueValues.ValueExpression, cd.UniqueValues.LookupModelAs);

            switch (cd.UniqueValues.LookupType) {
                case 'URL':
                    if (!cd.UniqueValues.lookupurlexpn && cd.UniqueValues.LookupURL)
                        cd.UniqueValues.lookupurlexpn = utils.compile(this, cd.UniqueValues.LookupURL);

                    return async (params) => {
                        if (!cd.UniqueValues.lookupurlexpn)
                            params.success([]);
                        else
                            try {
                                const dataurl = utils.evaluate(cd.UniqueValues.lookupurlexpn, this);

                                console.log(`getUniqueColValues url: ` + dataurl.split('&').join('\n'));

                                let res = await utils.api.get(dataurl);

                                switch (cd.UniqueValues.ValueType) {
                                    case 'Fieldname':
                                        res = res.map(a => a[cd.UniqueValues.ValueField]);
                                        break;
                                    case 'Expression':
                                        res = res.map(a => utils.evaluate(cd.UniqueValues.valueexpn, this, false, false, false, a));
                                        break;
                                }
                                console.log('getUniqueColValues res:' + JSON.stringify(res, null, 3));
                                params.success(res);
                            }
                            catch (err) {
                                params.success([]);
                                console.error(`Failed in getUniqueColValuesFunc (LookupURL:${cd.UniqueValues.LookupURL}):`);
                                console.error(err);
                            }
                    };

                case 'Interpolated':
                    if (!cd.UniqueValues.lookupexpn && cd.UniqueValues.LookupInterpolatedArray)
                        cd.UniqueValues.lookupexpn = utils.compileObject(this, cd.UniqueValues.LookupInterpolatedArray);

                    return (params) => {
                        if (!cd.UniqueValues.lookupexpn)
                            params.success([]);
                        else
                            try {
                                let res = utils.evaluateObject(cd.UniqueValues.lookupexpn, this);

                                switch (cd.UniqueValues.ValueType) {
                                    case 'Fieldname':
                                        res = res.map(a => a[cd.UniqueValues.ValueField]);
                                        break;
                                    case 'Expression':
                                        res = res.map(a => utils.evaluate(cd.UniqueValues.valueexpn, this, false, false, false, a));
                                        break;
                                }
                                params.success(res);
                            }
                            catch (err) {
                                params.success([]);
                                console.error(`Failed in getUniqueColValuesFunc (LookupInterpolatedArray:${JSON.stringify(cd.UniqueValues.LookupInterpolatedArray)}):`);
                                console.error(err);
                            }
                    };

                default:
                    return [];
            }
        },

        getGridMenuColumnList(h, menus) {
            if (!this.controlData.EnableDynamicColumns && this.columnDefs && this.columnDefs.length > 0) {
                for (let i = 0; i < this.columnDefs.length; i++) {
                    const col = this.columnDefs[i];
                    if (col.ActionOnlyColumn) continue;

                    menus.push(
                        <QItem key={`col_${i}`} clickable onClick={() => this.toggleColumnVisible(col.Name || col.Field, i)}>
                            <QItemSection avatar>
                                {this.columns_visible[i] ? <QIcon name="mdi-check" size="sm" /> : null}
                            </QItemSection>
                            <QItemSection>
                                <QItemLabel><TranslationContainer context={this} value={col.DisplayName || col.Name || col.Field} /></QItemLabel>
                            </QItemSection>
                        </QItem>
                    );
                }
            }
            else if (this.controlData.EnableDynamicColumns && this.dynamicColumns && this.columnTemplates) {
                const dc = this.dynamicColumnsValue;
                if (dc && Array.isArray(dc)) {
                    for (let i = 0; i < dc.length; i++) {
                        const cd = this.columnTemplates[dc[i].template];
                        if (!cd || !dc[i].field) continue;

                        //utils.debug(`pushing templated coldef for field:${dc[i].field}, template:${dc[i].template}`);
                        //coldefs.push(await this.generateColumnDef(h, cd, i, dc[i].field, '', dc[i].caption, true, dc[i].default_visible === undefined ? true : dc[i].default_visible));

                        menus.push(
                            <QItem key={`col_${i}`} clickable onClick={() => this.toggleColumnVisible(dc[i].field, i)}>
                                <QItemSection avatar>
                                    {this.columns_visible[i] ? <QIcon name="mdi-check" size="sm" /> : null}
                                </QItemSection>
                                <QItemSection>
                                    <QItemLabel>{dc[i].caption || dc[i].field}</QItemLabel>
                                </QItemSection>
                            </QItem>
                        );
                    }
                }
            }
        },

        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        rowCommandClick(e, data, btn) {
            e.cancelBubble = true;
            e.preventDefault();
            utils.executeAndCompileAllActions(btn.Actions, { RowIndex: data.rowIndex, Data: data.row.data }, this);
        },
        rowLinkClick(e, data, actions) {
            e.cancelBubble = true;
            e.preventDefault();
            utils.executeAndCompileAllActions(actions, { RowIndex: data.rowIndex, Data: data.row.data }, this);
        },
        rowMenuClick(e, data, btn, m) {
            //e.cancelBubble = true;
            //e.preventDefault();
            utils.executeAndCompileAllActions(m.Actions, { RowIndex: data.rowIndex, Data: data.row.data }, this);
        },
        menuOpenClose(state, data, btn, m) {
            if (btn.OnMenuOpen)
                utils.executeAndCompileAllActions(btn.OnMenuOpen, { RowIndex: data.rowIndex, Data: data.row.data, State: state }, this);
        },
        async runUserQuery(args) {
            //const q_from = args.startRow;
            //const q_size = args.endRow - args.startRow;
            //let dataurl = `${this.modelurlvalue}&PageSize=${q_size}&From=${q_from}`;

            // Invoke a user defined function and pass the params as well as a function
            // that is the API getter function to be used from within the user defined
            // function to submit the API request to fetch the actual data.
            if (this.dsFunc) {
                //const api = utils.apiWrapper;
                const chf = careHelpfulFunctions;
                const care = careService;
                const Control = this.scopeitems;
                const Params = this.Params;

                return await this.dsFunc(this.modelurlvalue, args, utils.api, care, chf, Control, Params);
            }

            return { rowData: [], rowCount: 0 };
        },
        async ExportData(all) {
            await this.resolveAllAdditionalRowData();
            await this.waitForAdditionalRowDataAsyncIdle();

            let columnKeys = this.column_defs.filter(c => c.colId);

            if (!all) {
                let columnVis = this.gridApi.getAllDisplayedColumns();
                columnVis = careHelpfulFunctions.toLookup(columnVis, 'colId');
                columnKeys = columnKeys.filter(c => c.colId in columnVis);
            }

            // A server-side grid holds only the blocks it has loaded, so its own CSV would be missing rows. A document
            // can take the export over with ExportActions, which run instead and receive Input.Data with All and the
            // Columns to export (colId, field, header) in grid order.
            if (this.controlData.ExportActions && this.controlData.ExportActions.length > 0) {
                const columns = columnKeys.map(c => ({ colId: c.colId, field: c.field, header: c.headerName }));
                await utils.executeAndCompileAllActions(this.controlData.ExportActions, { Data: { All: all, Columns: columns } }, this);
                return;
            }

            this.gridApi.exportDataAsCsv({ columnKeys: columnKeys.map(c => c.colId) });
        },
    },
    props: {},
    render() {
        if (!this.todisplay || !this.column_defs_ready)
            return null;

        const style = {
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            padding: '8px',
            position: 'relative',
            ...this.sizeStyle,
        };

        return (
            <div
                key={this.unique_id + '_main'}
                v-show={this.isvisible}
                class={{ 'c-FastGrid': true, [`c-name-${this.name || 'unnamed'}`]: true, 'ag-theme-alpine': true }}
                style={style}
            >
                {this.loading && (
                    <div class="absolute-full flex flex-center" style="background: rgba(255,255,255,0.6); z-index: 2;">
                        <QSpinner color="primary" size="64px" />
                    </div>
                )}

                {this.getGridHeaders()}
                <AgGridVue
                    key={this.unique_id}
                    ref="agGridRef"
                    class={{ 'ag-theme-alpine': true }}
                    style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
                    rowData={this.dataSource}
                    columnDefs={this.column_defs}
                    columnMenu="new"
                    autoGroupColumnDef={{ pinned: this.getGroupingOption('Pinned', null, false), lockPosition: this.getGroupingOption('LockPosition', null, false) }}
                    isGroupOpenByDefault={this.getIsOpenGroupOptionCallback()}
                    rowSelection={this.getRowSelectionConfig()}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                    quickFilterText={this.searchTextReader}
                    suppressScrollOnNewData={true}
                    suppressCellSelection={true}
                    suppressDragLeaveHidesColumns={true}
                    pagination={this.pagination}
                    paginationAutoPageSize={this.pagination}
                    getRowClass={this.getRowClass}
                    maintainColumnOrder={true}
                    editType={this.controlData.FullRowEditable ? 'fullRow' : undefined}

                    groupDisplayType={this.getGroupingOption('DisplayType', null, null)}
                    rowGroupPanelShow={this.getGroupingOption('PanelShow', 'panelshow_expn', 'never')}
                    groupDefaultExpanded={this.getGroupingOption('ColumnsExpanded', 'columnsexpanded_expn', 0)}
                    groupLockGroupColumns={this.getGroupingOption('ColumnsLocked', null, 0)}
                    suppressGroupRowsSticky={this.getGroupingOption('SuppressSticky', null, false)}
                    groupAllowUnbalanced={this.getGroupingOption('AllowUnbalanced', null, false)}
                    showOpenedGroup={this.getGroupingOption('ShowOpenedGroup', null, false)}
                    
                    rowModelType={this.rowModelType}
                    serverSideDatasource={this.serverSideDatasource}
                    columnTypes={this.dataTypeDefinitions}

                    onGridReady={this.onGridReady}
                    onFirstDataRendered={(e) => this.onFirstDataRendered(e)}
                    onSelectionChanged={(e) => this.rowSelectionChanged(e)}
                    onFilterChanged={this.columnFilterChanged}
                    onRowGroupOpened={(e) => this.onRowGroupOpened(e)}
                    onSortChanged={this.onSaveGridSortState}
                    onColumnVisible={this.onSaveGridColumnState}
                    onColumnPinned={this.onSaveGridColumnState}
                    onColumnResized={this.onSaveGridColumnState}
                    onColumnMoved={this.onSaveGridColumnState}
                    onColumnRowGroupChanged={this.onSaveGridColumnState}
                >
                </AgGridVue>
            </div>
        );

        /*

         * */


        //rowHeight={26}

        //const style = {
        //    overflow: "auto",
        //    display: "flex",
        //    flexDirection: "column",
        //    ...this.sizeStyle,
        //    maxHeight: "1000px",
        //};

        //let scopedSlots = {};
        //this.getHeaderControls(scopedSlots);

        //return (
        //    <DxDataGrid
        //        class={{ 'c-FastGrid': true, [`c-name-${this.name || 'unnamed'}`]: true }}
        //        style={style}
        //        data-source={this.dataSource}
        //        key-expr={this.controlData.KeyFields}
        //        allow-column-reordering={true}
        //        allow-column-resizing={true}
        //        column-resizing-mode="widget"
        //        column-auto-width={this.controlData.SizeColumnnsToContent}
        //        show-borders={true}
        //        show-row-lines={false}
        //        show-column-lines={true}
        //        row-alternation-enabled={true}
        //        word-wrap-enabled={false}
        //        scopedSlots={scopedSlots}
        //        selected-row-keys={this.selectedRowKeys}
        //        on-toolbar-preparing={(e) => this.onToolbarPreparing(e)}
        //        on-selection-changed={(s) => this.onSelectionChanged(s)}
        //    >
        //        <DxFilterRow visible={this.showFilter} />
        //        <DxSearchPanel visible={this.controlData.EnableFilter} />
        //        <DxScrolling mode={this.scrollMode} />
        //        {this.paging}
        //        {this.pager}
        //        <DxLoadPanel enabled={true} />
        //        <DxStateStoring enabled={true} type="custom" custom-load={this.loadState} custom-save={this.saveState} storage-key={this.storageKey} />
        //        {selector}

        //        {this.coldefs}
        //    </DxDataGrid>
        //);

        // <DxStateStoring enabled={true} type="localStorage" storage-key={this.storageKey} />
    }
});